const setDataScroll = (container) => {
  // Check if container is a DOM element
  if (!(container instanceof HTMLElement)) {
    // throw new Error("Container must be a DOM element")
    return
  }
  const scrollToBottom =  container.scrollHeight - container.scrollTop - container.getBoundingClientRect().height
  const scrollToTop = container.scrollTop
  container.dataset.scrollToTop = scrollToTop
  container.dataset.scrollToBottom = scrollToBottom
}



/**
 * Centers an element in a container
 * @param {HTMLElement} container - The container to center the element in
 * @param {HTMLElement} element - The element to center
 */
export function centerElementInContainer(container, element) {
  // Get the size of the container and element
  const containerRect = container.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()

  // Calculate the offset from the top left corner of the container to the top left corner of the element
  const offsetTop = elementRect.top - containerRect.top + container.scrollTop
  const offsetLeft = elementRect.left - containerRect.left + container.scrollLeft

  // Calculate the offset to center the element in the container
  const top = offsetTop - container.clientHeight / 2 + elementRect.height / 2
  const left = offsetLeft - container.clientWidth / 2 + elementRect.width / 2

  // Scroll the container to center the element
  try {
    container.scrollTo({ left, top, behavior: "smooth" })
  } catch {
    container.scrollTo(left, top)
  }

  // Update the data attributes
  setDataScroll(container)
  
}
